import { useScopedDialog } from '~/composables/use-scoped-dialog'
import AnonymousOrganizationContactUsModal from '~/components/Modals/AnonymousOrganizationContactUsModal.vue'

export function useAnonymousOrganizationContactUsModal(): (
    title: string,
    formMarkup: string,
    facilityId?: string
) => Promise<void> {
    const dialog = useScopedDialog()

    return (title: string, formMarkup: string, facilityId?: string) => {
        return new Promise(resolve => {
            dialog.open(AnonymousOrganizationContactUsModal, {
                props: {
                    header: title,
                    pt: {
                        root: {
                            class: 'w-full h-max-md:h-full max-h-full !rounded-none md:!w-[40rem]'
                        },
                        header: {
                            class: '!rounded-none text-xl font-semibold'
                        },
                        content: {
                            class: '!rounded-none flex-1 '
                        }
                    },
                    ptOptions: {
                        mergeProps: true
                    },
                    modal: true
                },
                data: {
                    formMarkup: formMarkup,
                    facilityId: facilityId
                },
                onClose: () => {
                    resolve()
                }
            })
        })
    }
}
